import React from "react";

export const Logo = () => {
  return (
    <>
      <img alt={'ロゴ'} style={{maxWidth: '400px'}} src={'/meishi-R-01.png'}/>
    </>
  )
}
